import { createSelector } from 'reselect';
import { Snackbar } from '../reducer/snackbarReducer';
import { RootState } from '../store/store';

const stateKey = 'snackbar';

export const snackbarListSelector = (state: RootState) => state.legacy[stateKey].snackbars;

export const makeCurrentSnackbarSelector = () => {
    return createSelector(
        [snackbarListSelector],
        (snackbarList): Snackbar|null => snackbarList[0] || null,
    );
};
